import { render, staticRenderFns } from "./SurfacePostMoreActions.vue?vue&type=template&id=035f6964&scoped=true&"
import script from "./SurfacePostMoreActions.vue?vue&type=script&lang=ts&"
export * from "./SurfacePostMoreActions.vue?vue&type=script&lang=ts&"
import style0 from "./SurfacePostMoreActions.vue?vue&type=style&index=0&id=035f6964&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "035f6964",
  null
  
)

export default component.exports